<template>
  <div class="custom-select relative z-4">
    <div
      class="input ba f6 pa3 pl2 w-100"
      @click="toggleOpen"
    >
      <div>
        <span
          class="tag"
          :style="getSelectedColor(selected)"
        >
        </span>
        {{selected}}
      </div>
    </div>
    <div
      class="choices-container absolute w-100 center"
      v-bind:class="{opened: isOpened}"
    >
      <div
        class="choices"
        v-bind:class="{opened: isOpened}"
      >
        <span
          class="close pa2 pr4"
          v-if="mobile"
          @click="toggleOpen"
        >
          <i class="fal fa-times"></i>
        </span>
        <ul
          class="list"
          style="list-style-type: none; width: 200px;"
        >
          <li
            class="pointer"
            v-for="option in finalOptions"
            :key="option.value"
            @click="selectOption(option)"
            v-bind:class="{active: activeOption == option.value}"
          >
            <span
              class="tag"
              :style="getColor(option)"
            >
            </span>
            {{option.text}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-select",
  props: ["options", "placeholder", "default"],
  data: () => {
    return {
      isOpened: false,
      activeOption: undefined,
      finalOptions: [],
      selected: undefined,
      mobile: false
    };
  },
  beforeMount: function() {
    this.setOptions();
    // this.mobile = window.innerWidth < 600;
  },
  methods: {
    selectOption(option) {
      this.$emit("change", option.value);
      let carousels = document.querySelectorAll(".VueCarousel");
      for (let carousel of carousels) {
        carousel.style.zIndex = 3;
      }
      this.activeOption = option.value;
      this.selected = option.text;
      this.isOpened = false;
    },
    setOptions() {
      if (typeof this.options[0] == "string") {
        let reformated = [];
        for (let [index, opt] of this.options.entries()) {
          reformated.push({ value: index, text: opt });
        }
        this.finalOptions = reformated;
      } else {
        this.finalOptions = this.options;
      }
      this.selected = this.placeholder
        ? this.placeholder
        : this.finalOptions[0]
        ? this.finalOptions[0].text
        : "";
      this.activeOption = this.finalOptions[0]
        ? this.finalOptions[0].value
        : "";
      this.findColor();
    },
    findColor() {
      if (this.default != null) {
        for (var i = 0; i < this.finalOptions.length; i++) {
          var formattedDefault = this.default.toLowerCase();
          var formattedOption = this.finalOptions[i].value.toLowerCase();
          if (formattedDefault == formattedOption) {
            this.selectOption(this.finalOptions[i]);
          }
        }
      }
    },
    findColorByName(color) {
      for (var i = 0; i < this.finalOptions.length; i++) {
        var formattedOption = this.finalOptions[i].text;
        if (color == formattedOption) {
          return this.finalOptions[i].value;
        }
      }
    },
    toggleOpen() {
      if (this.isOpened) {
        this.$emit("close"); //-> If opened, it means we close
        // Manage Carousels
        let carousels = document.querySelectorAll(".VueCarousel");
        for (let carousel of carousels) {
          carousel.style.zIndex = 3;
        }
      } else {
        this.$emit("open"); //-> If closed, it means we open
        // Manage Carousels
        let carousels = document.querySelectorAll(".VueCarousel");
        for (let carousel of carousels) {
          carousel.style.zIndex = -1;
        }
      }
      this.isOpened = !this.isOpened;
    },
    getColor(color) {
      return (
        "background-color: " + color.value + "; color: #FFFFFF; height: 13px;"
      );
    },
    getSelectedColor(color) {
      return (
        "background-color: " +
        this.findColorByName(color) +
        "; color: #FFFFFF; height: 13px;"
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.custom-select {
  position: relative;
  .input {
    // cursor: pointer;
    // font-size: 0.85em;
    line-height: -0.5em;
  }
  div {
    color: rgba(0, 0, 0, 0.7);
    margin-top: auto;
  }
}

.choices-container {
  pointer-events: none;
  background-color: white;
}

.choices {
  z-index: 1000;
  transform: translateY(-10000px);
  pointer-events: none;
  background-color: white;
  border: none;
  &.opened {
    // height: auto;
    background-color: white;
    transform: translateY(0px);
    pointer-events: auto;
  }
  max-height: 0px;
}

li {
  height: auto;
  background-color: white;
  color: rgb(189, 189, 189);
  padding: 8px;
  &.active {
    color: black;
    font-weight: bold;
  }
  margin-top: -0.5em;
}

li:hover {
  color: black;
}

.pointer {
  margin-top: 0px;
}

.list {
  background-color: white;
  margin-left: 0px;
  margin-top: 0;
  max-height: 200px;
  overflow-y: scroll;
  border-radius: 0 0 4px 4px;
}

@media screen and (max-width: 768px) {
  .choices-container {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;

    &.opened {
      position: fixed;
      background: rgba(0, 0, 0, 0.6);
    }
  }

  .choices {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    transition: 0.8s;
    transform: translateY(200%);
    pointer-events: none;
    padding: 0;
    // max-height: 290px;

    .close {
      position: absolute;
      right: 0;
    }

    &.opened {
      // height: auto;
      transform: translateY(0px);
      pointer-events: auto;
    }
  }
}
</style>